var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "image", class: _vm.wrapperClass, style: _vm.styles },
    [
      _c("img", {
        class: _vm.imageClasses,
        attrs: {
          src: _vm.imageSrc,
          "data-src": _vm.src,
          "data-widths":
            "[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]",
          "data-aspectratio": _vm.aspectRatio,
          "data-sizes": "auto",
          alt: _vm.altText
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }